import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import axios from 'axios'
import { getApiBaseUrl } from './config/api'

// 初始化全局变量
window.axiosCancelTokens = []

// 请求拦截器
axios.interceptors.request.use(config => {
  // 创建取消令牌
  const source = axios.CancelToken.source()
  config.cancelToken = source.token
  window.axiosCancelTokens.push(source.cancel)
  return config
})

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 从取消令牌列表中移除已完成的请求
    if (response.config?.cancelToken) {
      const index = window.axiosCancelTokens.indexOf(response.config.cancelToken.cancel)
      if (index > -1) {
        window.axiosCancelTokens.splice(index, 1)
      }
    }
    return response
  },
  error => {
    // 如果是取消的请求，不显示错误
    if (axios.isCancel(error)) {
      return new Promise(() => {})
    }
    // 从取消令牌列表中移除失败的请求
    if (error.config?.cancelToken) {
      const index = window.axiosCancelTokens.indexOf(error.config.cancelToken.cancel)
      if (index > -1) {
        window.axiosCancelTokens.splice(index, 1)
      }
    }
    return Promise.reject(error)
  }
)

// 配置axios
axios.defaults.baseURL = getApiBaseUrl()
axios.defaults.withCredentials = true  // 允许跨域请求携带凭证
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// 全局错误处理
axios.interceptors.response.use(
  response => response,
  error => {
    console.error('Response error:', error)
    return Promise.reject(error)
  }
)

// 全局处理ResizeObserver错误和Vue警告
const app = createApp(App)

app.config.warnHandler = () => null
window.addEventListener('error', (event) => {
  if (event.message.includes('ResizeObserver')) {
    event.stopPropagation()
    event.preventDefault()
  }
})

app.use(ElementPlus, {
  locale: zhCn
})
app.use(store)
app.use(router)

app.mount('#app') 